export class ResponseError extends Error {
  public statusCode: number;
  public body: any;
  constructor(public message: string, private response: Response) {
    super(message);
    this.statusCode = response.status;
    if (process.env.NODE_ENV !== 'production') {
      console.error('resp', response);
    }
  }
}
